export default __webpack_public_path__ + "static/media/Gloves of Lunacy.87a4e67a.jpg";